import type { Group, GroupId } from 'types/group'
import type { PlaylistVersionId } from 'types/playlist'
import type { PublicPlaylist } from 'types/public-playlist'
import type { PromiseType } from './server/base'
import BaseAPI from './server/base'

const getRequestParams = groupId => ({
  Accept: 'application/json',
  'X-Disco-GroupIDs': JSON.stringify([groupId]),
})

export default class Api extends BaseAPI {
  share_id: number | undefined = window.signed_share_id
  extraParameters: Record<string, any> = window.discogroup_data.extra_parameters
  getPlaylist: (playlist: Partial<PublicPlaylist>) => Promise<PublicPlaylist> =
    playlist => {
      if (playlist.public_url)
        return this.getUrl(playlist.public_url, null, 'api.getPlaylist')
      return this.getUrl(
        `${this.host}/api/public_playlist/${playlist.playlist_id}/`,
        {
          share_id: this.share_id,
        },
        'api.getPlaylist',
      )
    }
  publicSearch: (
    group: Group,
    search?: {
      q?: string
      playlist_version_id?: PlaylistVersionId
      offset?: number
    },
    abortSignal?: AbortSignal,
  ) => PromiseType<any> = (group, search, abortSignal) => {
    const {
      sort,
      exclude_playlist_types,
      /* territory_ids, */
    } = this.extraParameters
    return this.getUrl(
      `${this.host}/api/public_search/`,
      {
        share_id: this.share_id,
        sort: sort ? JSON.stringify(sort) : undefined,
        exclude_playlist_types: exclude_playlist_types
          ? JSON.stringify(exclude_playlist_types)
          : undefined,
        // territory_ids: territory_ids
        //   ? JSON.stringify(territory_ids)
        //   : undefined,
        ...search,
      },
      'api.getFolderContents',
      {
        headers: getRequestParams(group.id),
        abortSignal,
      },
    )
  }
  getGroupContentsNextPage: (
    groupId: GroupId,
    url: string,
  ) => PromiseType<any> = (groupId, url) =>
    this.getUrl(url, null, 'api.getGroupContentsNextPage', {
      headers: getRequestParams(groupId),
    })
  getChannelZipUrls: (url: string) => PromiseType<any> = url =>
    this.getUrl(url, null, 'api.getChannelZipUrls')
}
